import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '../components/kit';
import { Brand } from '../components/Brand';
import { api } from '../api/client';
import './auth.css';

export function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');

  useEffect(() => {
    if (!token) {
      setState('error');
      return;
    }
    api.post('/auth/verify-email', { token }).then(() => setState('ok')).catch(() => setState('error'));
  }, [token]);

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <aside className="auth-aside">
          <Brand variant="auth" />
          <div className="auth-aside-tag">Tahsilat ve ödeme süreçlerinizi kolaylaştıran akıllı çözüm.</div>
        </aside>
        <div className="auth-main" style={{ textAlign: 'center' }}>
          {state === 'loading' && (
            <>
              <h1>E-posta doğrulanıyor…</h1>
              <p className="auth-sub">Lütfen bekleyin.</p>
            </>
          )}
          {state === 'ok' && (
            <>
              <div style={{ fontSize: 44, marginBottom: 8 }}>✅</div>
              <h1>E-postanız onaylandı</h1>
              <p className="auth-sub">Artık hesabınıza giriş yapabilirsiniz.</p>
              <Link to="/giris"><Button className="auth-submit">Giriş yap</Button></Link>
            </>
          )}
          {state === 'error' && (
            <>
              <div style={{ fontSize: 44, marginBottom: 8 }}>⚠️</div>
              <h1>Bağlantı geçersiz</h1>
              <p className="auth-sub">Onay bağlantısı geçersiz veya süresi dolmuş. Yöneticinizden yeni bir bağlantı isteyin.</p>
              <Link to="/giris"><Button variant="secondary" className="auth-submit">Giriş sayfası</Button></Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
